import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import AuthContext from '../context/AuthContext';

const SuperAdminRoute = ({ children }) => {
    const { user } = useContext(AuthContext);
    const location = useLocation();

    // This component assumes the user is already authenticated
    // It only checks for the role
    if (!user || user.role !== 'superadmin') {
        // Redirect them to the home page if they are not a super admin
        // You could also show a "Forbidden" page
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    return children;
};

export default SuperAdminRoute;
